declare let gtag: Function; // eslint-disable-line

export class EventPublisher {
  private readonly window: Window;

  constructor(window: Window) {
    this.window = window;
  }

  public timing(category: string, label: string, timing: number) {
    if ((window as any).enableGa && gtag !== undefined) {
      console.log(`Sending timing event: ${category}`, label, timing);
      gtag("event", "timing_complete", {
        event_category: category,
        event_label: label,
        value: timing,
      });
    } else {
      console.log(`Not sending timing event: ${category}`, label, timing);
    }
  }

  public event(
    eventName = "method",
    category: string,
    eventLabel: string | undefined = undefined,
    value: string
  ) {
    if ((window as any).enableGa && gtag !== undefined) {
      console.log("Sending event:", eventName, category, eventLabel, value);
      gtag("event", eventName, {
        event_label: eventLabel,
        event_category: category,
        value: value,
      });
    } else {
      console.log("Not sending event:", eventName, category, eventLabel, value);
    }
  }
}
